//@vendor
const get = require('lodash/object/get');
//@constants
const actionTypes = require('constants/actionTypes');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
//@actions
const { requestDecreaseLimit } = require('actions/cardModifyNewLimit/cardDecreaseLimit');
const { requestIncreaseLimit } = require('actions/cardModifyNewLimit/cardIncreaseLimit');
//@utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const { formatText } = require('core/i18n').i18n;
const { NOT_MAX_LIMIT, CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE } = require('constants/index');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const processEmailLoading = () => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_PROCESS_EMAIL_LOADING
});

const processEmailSuccess = () => (dispatch) => {
    dispatch({
        type: actionTypes.HIRE_CARD_CREDIT_CARD_CREDIT_PROCCESS_EMAIL_SUCCESS,
    });

    dispatch({
        type: actionTypes.PRE_CONTRACTUAL_MAIL_SENT_SUCCESS,
    });
};
const processEmailError = () => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_PROCESS_EMAIL_ERROR
});
const nextStep = (step, valid) => (dispatch, getState) => {
    const isRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    dispatch({
        type: actionTypes.CARD_MODIFY_NEW_LIMIT_VALIDATE_STEP,
        payload: {
            step,
            isRevolving,
            valid
        }
    });
};

const resetStep = limit => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_RESET_STEP,
        payload: {
            limit
        }
    };
};
const setCardId = cardId => {
    return {
        type: actionTypes.CARD_MODIFY_NEW_LIMIT_CARD_ID,
        payload: {
            cardId
        }
    };
};
const setAgreementCheckbox = evt => ({
    type: actionTypes.CARD_MODIFY_LIMIT_SET_AGREEMENT_CHECKBOX,
    payload: {
        checked: evt.target.checked
    }
})
const onHandleChangeCheckBoxCC = () => ({
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX_CC,
});
function setVisibleStep(step) {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}
const hireCreditLimitRequest = () => ({
    type: actionTypes.HIRE_CREDIT_LIMIT_REQUEST
});
const hireCreditLimitFailure = error => ({
    type: actionTypes.HIRE_CREDIT_LIMIT_FAILURE,
    payload: {
        error
    }
});

const getInitParams = () => (dispatch, getState) => {
    const revolvingPersistentData = getState().revolvingPersistentData;
    const immCardChangePaymentMethod = getState().cardModifyNewLimit;
    const immHireCreditLimit = getState().hireCreditLimit;
    const creditLimit = immHireCreditLimit.get('creditLimit');
    const cardId = immCardChangePaymentMethod.get('cardId');
    const immCard = getState().cards.get('byId').get(cardId);
    const calculationType = revolvingPersistentData.getIn(['paramsAFI', 'calculationType']);
    const interestRate = revolvingPersistentData.getIn(['paramsAFI', 'interestRate']);
    const typePayment = revolvingPersistentData.getIn(['paramsAFI', 'typePayment']);
    const fixedPaymentAmount = revolvingPersistentData.getIn(['paramsAFI', 'valuePayment']);
    const tae = revolvingPersistentData.getIn(['paramsInne', 'tae']);
    const productType = immCard.getIn(['product', 'type'])
    const standard = immCard.getIn(['product', 'standard'])
    const productSubType = immCard.getIn(['product', 'subtype'])
    const paymentMethodMap = { "FixedPaymentAmount": "FIXED", "PercentagePaymentRate": "VARIABLE" };
    const paymentMethod = paymentMethodMap[typePayment] || "UNIQUE";
    const amount = immCard.getIn(['limit', 'amount'])
    const contractNumberAccount = immCard.get('fullContractNumber')
    const processType = "precontractual_limit_payment_change"
    const calculationTypeMap = { 0: 0, 1: 1 };
    const mappedCalculationType = calculationTypeMap[calculationType] !== undefined ? calculationTypeMap[calculationType] : 3;

    const dataAfiSimulator = paymentMethod === "FIXED" ? {
        calculationType: mappedCalculationType,
        interestRate: interestRate,
        returnFlows: false,
        fixedPaymentAmount
    } : paymentMethod === "VARIABLE" ? {
        calculationType: mappedCalculationType,
        interestRate: interestRate,
        returnFlows: false,
        percentagePaymentRate: fixedPaymentAmount
    } : {
        calculationType: mappedCalculationType,
        interestRate: interestRate,
    }
    return {
        query:
        {
            product: {
                type: productType,
                subtype: productSubType,
                standard: standard,
            },
            processType,
            dataAfiSimulator,
            tae,
            paymentMethod,
            amount: creditLimit,
            contractNumberAccount
        }
    }
};
const processEmail = (step) => (dispatch, getState) => {
    const immCardChangePaymentMethod = getState().cardModifyNewLimit;

    const cardId = immCardChangePaymentMethod.get('cardId');
    const immCard = getState().cards.get('byId').get(cardId);
    const productType = immCard.getIn(['product', 'type'])
    const productSubType = immCard.getIn(['product', 'subtype'])
    const standard = immCard.getIn(['product', 'standard'])

    const documentId = immCardChangePaymentMethod.get('documentId')
    const operationProcessIdInit = immCardChangePaymentMethod.get('operationProcessIdInit')

    let acceptanceText;
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
        acceptanceText = 'NA'
    }
    if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
        acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
    }
    if (!__CONTACT_CENTER__) {
        acceptanceText = formatText('hireCardOpenCreditStepINE-labelCheckbox')
    }

    const documentIdDIR = immCardChangePaymentMethod.get('documentIdDIR')

    const params = {
        query: {

            product: {
                type: productType,
                subtype: productSubType,
                standard: standard
            },
            contactCenter: false,
            sendInsuranceDocument: true,
            sendRelevantRevolvingDocument: false,
            documentId,
            contractNumber: 0,
            mailType: "precontractual_payment_change",
            operationProcessId: operationProcessIdInit,
            acceptanceText,
            documents: [
                {
                    documentId: immCardChangePaymentMethod.get('documentIdINE'),
                    scrollDown: true,
                },
                ...(documentIdDIR ? [{
                    documentId: documentIdDIR,
                    scrollDown: true,
                }] : [])
            ],
        }
    };
    dispatch(processEmailLoading());

    return APIPost({
        dispatch,
        endpoint: 'hiringCardsSimple',
        params
    })
        .then(() => {
            dispatch(nextStep(step, true));
            dispatch(processEmailSuccess());

        })
        .catch(response => {
            if (!!response.error) {
                dispatch(processEmailError());
            }
        });
};

const validateINEDIRStep = step => (dispatch, getState) => {

    const immCardChangePaymentMethod = getState().cardModifyNewLimit;
    const immCards = getState().cards;
    const documentINE = immCardChangePaymentMethod.get('initialDocumentsList');
    const documentINESize = documentINE.size < 2
    dispatch(nextStep(step, true));
    const params = dispatch(getInitParams())
    return documentINESize && dispatch(hireCardCreditINE.getInitINEDIRstep(immCards, false, params));
};
const validatePolicyStep = () => (dispatch, getState) => {
    const immCardChangePaymentMethod = getState().cardModifyNewLimit;
    const immHireCreditLimit = getState().hireCreditLimit;
    const creditLimit = immHireCreditLimit.get('creditLimit');

    const cardId = immCardChangePaymentMethod.get('cardId');
    const immCard = getState().cards.get('byId').get(cardId);
    const productType = immCard.getIn(['product', 'type'])
    const productSubType = immCard.getIn(['product', 'subtype'])
    const standard = immCard.getIn(['product', 'standard'])
    const immCardChangeNewPaymentMethod = getState().cardChangeNewPaymentMethod;
    const documentPolicy = immCardChangeNewPaymentMethod.get('documentPolicy')

    const product = {
        type: productType,
        standard: standard,
        subtype: productSubType,
        cardId,
        contractNumber: immCard.get('fullContractNumber'),
        processType: "contract_limit_payment_change",
        amount: creditLimit
    }
    !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immCardChangeNewPaymentMethod, product));
};
const validateStepThree = step => (dispatch, getState) => {

    const policyDocument = getState().cardModifyNewLimit.get('documentPolicy');
    !policyDocument && dispatch(processEmail(step)).then(() => {
        dispatch(validatePolicyStep());
    });

    policyDocument && dispatch(nextStep(step, true));

};
const validateStep = step => (dispatch, getState) => {
    switch (step) {
        case 1:
            dispatch(validateINEDIRStep(step));
            break;
        case 2:
            dispatch(validateStepThree(step));
            break;
        default:
            break;
    }

    return dispatch(getStep(step));
};
const getStep = step => (dispatch, getState) => {
    const valid = getState().cardChangeNewPaymentMethod.getIn([__CONTACT_CENTER__ && !isPrintOfficeMode() ? 'stepsCC' : 'steps', step - 1, 'valid']);
    if (!valid) {
        scrollToTop();
    }
    return valid;
};
function setWillCancel(willCancel) {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function clearRequestModifyLimit() {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_CLEAR
    };
}
function clearRequestLimit() {
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_RESET
    };
}

const clearRequest = () => dispatch => {

    dispatch(clearRequestModifyLimit());
    dispatch(clearRequestLimit());

};

const cardIncreaseLimitsRequest = () => {
    return {
        type: actionTypes.CARD_INCREASE_LIMITS_REQUEST
    };
};

const cardIncreaseLimitsSuccess = () => {
    return {
        type: actionTypes.CARD_INCREASE_NEW_LIMITS_SUCCESS,

    };
};




const modifyLimit = cardId => (dispatch, getState) => {
    const immHireCreditLimit = getState().hireCreditLimit;
    const immCardChangePaymentMethod = getState().cardModifyNewLimit;
    const immCard = getState().cards.getIn(['byId', cardId]);
    const amount = immCard.getIn(['limit', 'amount'])
    const creditLimit = immHireCreditLimit.get('creditLimit');
    const documentIdPolicy = immCardChangePaymentMethod.get('documentIdPolicy');
    if (amount > creditLimit) {
        dispatch(requestDecreaseLimit(cardId, amount, creditLimit, documentIdPolicy));
    } else {
        dispatch(requestIncreaseLimit(cardId, documentIdPolicy));
    }
};

const requestLimits = cardId => (dispatch, getState) => {

    dispatch(setCardId(cardId));
    dispatch(cardIncreaseLimitsRequest());
    dispatch(cardIncreaseLimitsSuccess());
};
const getNewCreditCardData = (cardData) => (dispatch, getState) => {
    dispatch(setNewCreditCardData(cardData));
}
const setNewCreditCardData = (cardData) => ({
    type: actionTypes.HIRE_NEW_CREDIT_CARD_SET_DATA_CARD,
    payload: cardData,

});
const hireNewCreditLimitSucess = (response, productType, productSubType, referenceStandard, defaultLimit, newMaximumLimitAuthorize) => {
    const marks = get(response, ['tarjetaList', 'tarjetaList', 0, 'limitesCreditoList', 'limitesCreditoList'], []);
    const channel = get(response, ['tarjetaList', 'tarjetaList', 0, 'tarjetaRef', 'canal']);
    const maximumLimitAuthorize = get(response, 'limiteMaximoAutorizar') || false;
    const maximumLimitAuthorizeParse = parseInt(maximumLimitAuthorize, 10).toString();
    const index = marks.findIndex(mark => mark === maximumLimitAuthorizeParse);
    const slicedMarks = index !== -1 ? marks.slice(0, index + 1) : marks;
    const maxValue = maximumLimitAuthorize === NOT_MAX_LIMIT ? slicedMarks[slicedMarks.length - 1] : maximumLimitAuthorize ? maximumLimitAuthorizeParse : marks[marks.length - 1] || 0
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_SUCCESS,
        payload: {
            defaultLimit: newMaximumLimitAuthorize,
            productType,
            productSubType,
            referenceStandard,
            marks: maximumLimitAuthorize ? slicedMarks : marks,
            maxValue: maxValue,
            maxValueToAuthorize: Math.min(response.limiteMaximoAutorizar || 0, CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE),
            maximumLimitAuthorize,
            newMaximumLimitAuthorize,
            channel
        }
    };
};
const getHireCreditLimit = (productType, productSubType, referenceStandard, defaultLimit, newMaximumLimitAuthorize, amount) => (dispatch, getState) => {
    if (!getState().hireCreditLimit.get('isFetching')) {
        const params = {
            header: {
                version: 2,
            },
            query: {
                tipo: productType,
                subtipo: productSubType,
                standard: referenceStandard,
                amount
            }
        };

        dispatch(hireCreditLimitRequest());
        return APIGet({
            dispatch,
            endpoint: 'hireCards',
            params
        })
            .then(response => {
                dispatch(hireNewCreditLimitSucess(response, productType, productSubType, referenceStandard, defaultLimit, newMaximumLimitAuthorize))
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(hireCreditLimitFailure(response.error));
                } else {
                    throw response;
                }
            });

    }
};
const getHiring = (productType, productSubType, referenceStandard, defaultLimit, cardId, amount) => (dispatch, getState) => {
    const immCards = getState().cards;
    const immCard = immCards.getIn(['byId', cardId]);
    const newMaximumLimitAuthorize = immCard.getIn(['limit', 'amount'])
    dispatch(getHireCreditLimit(productType, productSubType, referenceStandard, defaultLimit, newMaximumLimitAuthorize, amount));

};

module.exports = {
    setAgreementCheckbox,
    resetStep,
    setVisibleStep,
    validateStep,
    setWillCancel,
    modifyLimit,
    clearRequest,
    requestLimits,
    getHiring,
    getNewCreditCardData,
    processEmail,
    onHandleChangeCheckBoxCC
};
